import React from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../config/redux/reducers";
import { useUACHelper } from '../../contexts/UACContext';
import UACConstants from '../../constants/UACConstants';
import BaseDriverDetails from "../shared/codPortalBaseDriverDetails";
import {
  fetchOrdersList,
  reconcileCollectedAmtForStdOrder,
  openCollectionConfirmation,
} from "./redux/stdCodPortalSlice";
import {
  codPortalOrdersDataTransform,
  createPayloadToFetchOrdersList,
  createPayloadToCollectAmount,
} from "../../mocks/stdCodPortal/response.transforms";
import { getConsignmentStatusField } from "../../mocks/SharedTransform/response.transforms";

interface StandardCodDriverDetailsProps {
  open: boolean;
  driverDetails: any;
  dashboardHub: any;
  dateRange: any;
  closePopup: () => void;
}

const StandardCodDriverDetails = (props: StandardCodDriverDetailsProps) => {
  const {
    ordersData,
    loading,
    isAmtCollected,
    ordersFiltersDropdowns,
    ordersOnDriverDetails,
    codAmtOnDriverDetails,
    codPendingOnDriverDetails,
    codReceivedOnDriverDetails,
    totalOrdersAmtOnDriverDetails,
  } = useSelector((state: AppState) => state.stdCodPortal);
  
  const uacHelper = useUACHelper();
  const canEditStandardCOD = uacHelper.canEdit(UACConstants.SD_COD);

  const { countryCode } = useSelector((state: AppState) => state.common);

  // Standard implementation doesn't use the Rapyd icon, so no custom renderer needed

  return (
    <BaseDriverDetails
      {...props}
      reduxStates={{
        ordersData,
        loading,
        isAmtCollected,
        ordersFiltersDropdowns,
        ordersOnDriverDetails,
        codAmtOnDriverDetails,
        codPendingOnDriverDetails,
        codReceivedOnDriverDetails,
        totalOrdersAmtOnDriverDetails,
      }}
      transforms={{
        codPortalOrdersDataTransform: codPortalOrdersDataTransform,
        getConsignmentStatusField,
        createPayloadToFetchOrdersList,
        createPayloadToCollectAmount,
      }}
      actions={{
        fetchOrdersList,
        reconcileCollectedAmt: reconcileCollectedAmtForStdOrder,
        openCollectionConfirmation,
      }}
      canEdit={canEditStandardCOD}
      countryCode={countryCode}
    />
  );
};

export default StandardCodDriverDetails;